import { sendRequest } from './send-request';

export const FulfillmentPrimaryActions = [sendRequest];
